export default "__VITE_ASSET__B7mBLO_C__"